import { render } from "./QuestionEdit.vue?vue&type=template&id=260ac259&scoped=true"
import script from "./QuestionEdit.vue?vue&type=script&lang=js"
export * from "./QuestionEdit.vue?vue&type=script&lang=js"

import "./QuestionEdit.vue?vue&type=style&index=0&id=260ac259&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260ac259"],['__file',"src/components/question/QuestionEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "260ac259"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('260ac259', __exports__)) {
    api.reload('260ac259', __exports__)
  }
  
  module.hot.accept("./QuestionEdit.vue?vue&type=template&id=260ac259&scoped=true", () => {
    api.rerender('260ac259', render)
  })

}


export default __exports__